import { Injectable, EventEmitter, Inject } from '@angular/core';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { SessionService } from './../../../services/session.service';
import { HttpClient, HttpBackend } from '@angular/common/http';
import { map, catchError } from 'rxjs/operators';
import { DOCUMENT } from '@angular/common';
import { Router } from '@angular/router';
import {
  TECH_LIB_PORTAL_CONFIG,
  TechLibPortalConfig,
} from '../../../tech-lib-portal.interceptor';
import { PortfolioDataInterface } from '../request/interfaces/portfolio-data.interface';
import { PortfolioanalysisSumaryInterface } from '../request/interfaces/portfolioanalysis-sumary.interface';
import { FixedperiodsInterfece } from '../request/interfaces/fixedperiods.interface';
import { PortfolioanalysisPositionsInterface } from '../request/interfaces/portfolioanalysis-positions.interface';
import { PortfolioanalysisAssetsInterface } from '../request/interfaces/portfolioanalysis-assets.interface';
import { PortfolioanalysisTradesInterface } from '../request/interfaces/portfolioanalysis-trades.interface';
import { PortfolioInterface } from '../request/interfaces/portfolio.interface';
import { ProfilePortfolioEnum } from '../../../services/api-names';
import { Utils } from '../../../utils/utils';

@Injectable({
  providedIn: 'root',
})
export class ProfileportfolioService {
  public portfolioCode: string;
  public idClient: string;
  public loadingRiskValuations: boolean = true;
  public portfolioanalysisPositions: PortfolioanalysisPositionsInterface;

  constructor(
    @Inject(TECH_LIB_PORTAL_CONFIG) private config: TechLibPortalConfig,
    private httpBackend: HttpBackend,
    private session: SessionService,
    private router: Router,
    private http: HttpClient
  ) {}

  getPortfolios(clientId: string): Observable<[any]> {
    var url = this.config.baseApi + ProfilePortfolioEnum.apirest_get_portfolios;
    this.idClient = clientId;
    return this.http.get<any>(url).pipe(
      map((res) => {
        localStorage.setItem('SessionClientToken', this.session.sessionToken);

        return res;
      }),
      catchError((err) => {
        this.router.navigate(['/login']);
        return throwError(err);
      })
    );
  }

  getPortfolioData(portfolioCode): Observable<PortfolioDataInterface> {
    this.portfolioCode = portfolioCode;
    let url = Utils.formatString(
      this.config.baseApi + ProfilePortfolioEnum.get_portfolioData,
      [this.portfolioCode]
    );

    return this.http.get<PortfolioDataInterface>(url).pipe(
      map((res) => {
        localStorage.setItem('SessionClientToken', this.session.sessionToken);
        return res;
      }),
      catchError((err) => {
        return throwError(err);
      })
    );
  }

  getPortfolioAnalysis(json: string): Observable<any> {
    //Este servicio esta creado como <any> porque dependiendo del Json
    //que reciba la estructura de response sera distinta.
    //Habra que recogerlo al suscribirse con la estructura correcta
    let url = this.config.baseApi + ProfilePortfolioEnum.get_portfolioanalysis;

    const bodyRequest = json;
    this.loadingRiskValuations = true;
    return this.http.post<any>(url, bodyRequest).pipe(
      map((res) => {
        localStorage.setItem('SessionClientToken', this.session.sessionToken);
        return res;
      }),
      catchError((err) => {
        return throwError(err);
      })
    );
  }

  getFixedperiods(code: string): Observable<[FixedperiodsInterfece]> {
    let url = Utils.formatString(
      this.config.baseApi + ProfilePortfolioEnum.get_fixedperiods,
      [code]
    );

    return this.http.get<[FixedperiodsInterfece]>(url).pipe(
      map((res) => {
        localStorage.setItem('SessionClientToken', this.session.sessionToken);
        return res;
      }),
      catchError((err) => {
        return throwError(err);
      })
    );
  }

  GetPortfolioPdfUrlReport(
    code: string,
    startDate: string,
    endDate: string
  ): Observable<any> {
    let url = Utils.formatString(
      this.config.baseApi + ProfilePortfolioEnum.get_portfolioPdfUrlReport,
      [code, startDate, endDate]
    );
    return this.http.get<any>(url).pipe(
      map((res) => {
        localStorage.setItem('SessionClientToken', this.session.sessionToken);
        return res;
      }),
      catchError((err) => {
        return throwError(err);
      })
    );
  }

  public updateAliasPortfolio(newAlias: string): Observable<any> {
    let url = Utils.formatString(
      this.config.baseApi + ProfilePortfolioEnum.update_alias_contract,
      [this.portfolioCode]
    );

    const bodyRequest = '{ "Alias": "' + newAlias + '"}';
    return this.http.post<any>(url, bodyRequest).pipe(
      map((res) => {
        localStorage.setItem('SessionClientToken', this.session.sessionToken);
        return res;
      }),
      catchError((err) => {
        //this.commonService.errorManager('get_portfolioPdfUrlReport', err);
        return throwError(err);
      })
    );
  }

  getPortfolioDiscretePerformance(code: string, calcType: string, period: string): Observable<any> {
    let url = Utils.formatString(
      this.config.baseApi + ProfilePortfolioEnum.get_portfolioDiscretePerformance,
      [code, calcType, period]
    );
    return this.http.get<any>(url).pipe(
      map((res) => {
        localStorage.setItem('SessionClientToken', this.session.sessionToken);
        return res.PortfolioDiscretePerformances;
      }),
      catchError((err) => {
        return throwError(err);
      })
    );
  }
}
